/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Parser from 'html-react-parser';

class MatViewSelection extends Component {

	constructor(props) {
		super(props);
		this.state = {
			selectValues: [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0]
		}
		this.middleHandleChange = this.middleHandleChange.bind(this);
	}

  	middleHandleChange(event) {
    	this.props.dispatch({
			type: 'SET_STATE',
			state: {
				middleMatGapInCM: event.target.value,
				matsUpdated: this.props.matsUpdated === 1 ? 0 : 1
			}
	    });
  	}

	createMatView = (matTop, matMiddle) => {
		let matView = [];
		matView.push(matTop);
		matView.push(matMiddle);
		return matView;
	}

	handleMatsViewChange(size) {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				matView: size
			}
	    });
	}

	render() {
		const {selectedMatSize} = this.props;
		const selectOptions = this.state.selectValues.map((size, key) => {
			return (
				<option key={key} value={size}>{size+'cm'}</option>
			)
	    })
		const MatOptionTop =
			<div className="col-sm-12 m-b-5" key="topmat">
				<div className="row">
					<div className="col-xs-6">
						<a href="#!" className="selectionArea" onClick={this.handleMatsViewChange.bind(this, 1)}>
							<div className="col-sm-3" style={{backgroundColor: this.props.selectedTopMat.getIn(['acf', 'color'])}}></div>
							<div className="col-sm-9" style={{padding: '5px'}}>
								<span>Top</span>
								{this.props.selectedTopMat.size > 0 ? <span>{Parser(this.props.selectedTopMat.getIn(['title', 'rendered']))}</span> : ''}
							</div>
						</a>
					</div>
				</div>
			</div>;
		const MatOptionMiddle =
			<div className="col-sm-12 m-b-5" key="middlemat">
				<div className="row">
					<div className="col-xs-6">
						<a href="#!" className="selectionArea" onClick={this.handleMatsViewChange.bind(this, 2)}>
							<div className="col-sm-3" style={{backgroundColor: this.props.selectedMiddleMat.getIn(['acf', 'color'])}}></div>
							<div className="col-sm-9" style={{padding: '5px'}}>
								<span>Middle</span>
								{this.props.selectedMiddleMat.size > 0 ? <span>{Parser(this.props.selectedMiddleMat.getIn(['title', 'rendered']))}</span> : ''}
							</div>
						</a>
					</div>
					<div className="col-xs-6">
						<select className="col-sm-12" value={this.props.middleMatGapInCM} onChange={this.middleHandleChange}>
				        	{selectOptions}
				        </select>
					</div>
				</div>
			</div>;

		let MatViewOptions = '';
		if ( parseFloat(selectedMatSize) === 1 ) {
			MatViewOptions = this.createMatView(MatOptionTop, '');
		} else if ( parseFloat(selectedMatSize) === 2 ) {
			MatViewOptions = this.createMatView(MatOptionTop, MatOptionMiddle);
		}

		return (
			<div className="row">
				{MatViewOptions}
			</div>
		);
	}
}
export default MatViewSelection;